module.exports = __webpack_public_path__ + "static/helenBig-b142bfc4861dc4d3197ceaefb19c9f88.png";